// extracted by mini-css-extract-plugin
module.exports = {"withMapOverlay":"heading-title_withMapOverlay__yM5lv"};